import {
  useEffect,
  useState,
} from "react";

import axios from "../../../utils/api";

import {
  createBooking,
} from "../../../api/bookingEngine";

import getBookingSubdomain from "../../../utils/getBookingSubdomain";


const DEFAULT_GUEST_FORM = {
  name: "",
  mobile: "",
  email: "",
  specialRequest: "",
};


const useBookingModal = ({
  searchDetails,
  subdomain,
}) => {

  /* =========================================================
     OFFERS
  ========================================================= */

  const [offers, setOffers] =
    useState([]);


  useEffect(() => {

    console.log(
      "🎁 OFFERS EFFECT FIRED"
    );

    console.log(
      "🏨 SUBDOMAIN FROM BOOKING ENGINE:",
      subdomain
    );


    let mounted = true;


    const fetchOffers = async () => {

      try {

        /* =====================================================
           GET BOOKING SUBDOMAIN
        ===================================================== */

        const bookingSubdomain =
          subdomain ||
          getBookingSubdomain();


        console.log(
          "🏨 FINAL BOOKING SUBDOMAIN:",
          bookingSubdomain
        );


        /* =====================================================
           STOP IF SUBDOMAIN IS MISSING
        ===================================================== */

        if (!bookingSubdomain) {

          console.error(
            "❌ CANNOT FETCH OFFERS: SUBDOMAIN IS MISSING"
          );

          return;

        }


        /* =====================================================
           PUBLIC BOOKING ENGINE OFFERS API
           
           IMPORTANT:
           This must match your backend route.
        ===================================================== */

        const offersUrl =
          `/booking-engine/${bookingSubdomain}/offers`;


        console.log(
          "🎁 OFFERS API URL:",
          offersUrl
        );


        /* =====================================================
           API CALL
        ===================================================== */

        const response =
          await axios.get(
            offersUrl
          );


        console.log(
          "🎁 OFFERS API RESPONSE:",
          response
        );


        console.log(
          "🎁 OFFERS API DATA:",
          response?.data
        );


        /* =====================================================
           READ OFFERS
        ===================================================== */

        const publicOffers =
          Array.isArray(
            response?.data?.offers
          )
            ? response.data.offers
            : [];


        console.log(
          "🎁 OFFERS RECEIVED:",
          publicOffers
        );


        /* =====================================================
           FRONTEND SAFETY FILTER
        ===================================================== */

        const reservationOffers =
          publicOffers.filter(
            (offer) => {

              const isActive =
                offer?.isActive === true;

              const correctType =
                offer?.offerType ===
                "RESERVATION";


              console.log(
                "🎁 CHECKING OFFER:",
                {
                  name:
                    offer?.name,

                  code:
                    offer?.code,

                  offerType:
                    offer?.offerType,

                  isActive:
                    offer?.isActive,

                  isActiveResult:
                    isActive,

                  typeResult:
                    correctType,
                }
              );


              return (
                isActive &&
                correctType
              );

            }
          );


        console.log(
          "🎁 RESERVATION OFFERS:",
          reservationOffers
        );


        if (mounted) {

          setOffers(
            reservationOffers
          );

        }

      } catch (error) {

        console.error(
          "❌ OFFERS API FAILED:",
          error
        );


        console.error(
          "❌ RESPONSE:",
          error?.response
        );


        console.error(
          "❌ RESPONSE DATA:",
          error?.response?.data
        );


        if (mounted) {

          setOffers([]);

        }

      }

    };


    fetchOffers();


    return () => {

      mounted = false;

    };

  }, [
    subdomain,
  ]);


  /* =========================================================
     BOOKING STATE
  ========================================================= */

  const [selectedRoom, setSelectedRoom] =
    useState(null);

  const [
    bookingSearchDetails,
    setBookingSearchDetails,
  ] =
    useState(null);

  const [
    isBookingModalOpen,
    setIsBookingModalOpen,
  ] =
    useState(false);

  const [
    bookingLoading,
    setBookingLoading,
  ] =
    useState(false);

  const [
    guestForm,
    setGuestForm,
  ] =
    useState(
      DEFAULT_GUEST_FORM
    );


  /* =========================================================
     ROOM SELECT
  ========================================================= */

  const handleRoomSelect =
    (room) => {

      console.log(
        "🛏️ OPEN BOOKING:",
        room
      );


      if (!room) {

        console.error(
          "❌ No room received"
        );

        return;

      }


      const currentSearch = {

        checkIn:
          searchDetails?.checkIn ||
          "",

        checkOut:
          searchDetails?.checkOut ||
          "",

        adults:
          Number(
            searchDetails?.adults ||
            1
          ),

        children:
          Number(
            searchDetails?.children ||
            0
          ),

      };


      if (
        !currentSearch.checkIn
      ) {

        alert(
          "Please select your check-in date first."
        );

        return;

      }


      if (
        !currentSearch.checkOut
      ) {

        alert(
          "Please select your check-out date first."
        );

        return;

      }


      if (
        currentSearch.checkIn >=
        currentSearch.checkOut
      ) {

        alert(
          "Check-out date must be after check-in date."
        );

        return;

      }


      setSelectedRoom(
        room
      );


      setBookingSearchDetails(
        currentSearch
      );


      setIsBookingModalOpen(
        true
      );

    };


  /* =========================================================
     GUEST FORM
  ========================================================= */

  const handleGuestChange =
    (e) => {

      const {
        name,
        value,
      } = e.target;


      setGuestForm(
        (previous) => ({

          ...previous,

          [name]:
            value,

        })
      );

    };


  /* =========================================================
     BOOKING SUBMIT
  ========================================================= */

  const handleBookingSubmit =
    async (e) => {

      if (
        e?.preventDefault
      ) {

        e.preventDefault();

      }


      if (
        !guestForm.name.trim()
      ) {

        alert(
          "Please enter your name."
        );

        return;

      }


      if (
        !guestForm.mobile.trim()
      ) {

        alert(
          "Please enter your mobile number."
        );

        return;

      }


      if (
        !guestForm.email.trim()
      ) {

        alert(
          "Please enter your email."
        );

        return;

      }


      if (
        !selectedRoom
      ) {

        alert(
          "Please select a room first."
        );

        return;

      }


      if (
        !bookingSearchDetails
      ) {

        alert(
          "Booking dates are missing. Please select the room again."
        );

        return;

      }


      const bookingPayload = {

        room:
          selectedRoom,

        searchDetails:
          bookingSearchDetails,

        guest:
          guestForm,

        roomTypeId:
          selectedRoom.roomTypeId ||
          selectedRoom.id ||
          selectedRoom._id,

        checkIn:
          bookingSearchDetails.checkIn,

        checkOut:
          bookingSearchDetails.checkOut,

        adults:
          Number(
            bookingSearchDetails.adults ||
            1
          ),

        children:
          Number(
            bookingSearchDetails.children ||
            0
          ),

        guestName:
          guestForm.name.trim(),

        name:
          guestForm.name.trim(),

        mobile:
          guestForm.mobile.trim(),

        email:
          guestForm.email.trim(),

        specialRequest:
          guestForm.specialRequest?.trim() ||
          "",

        advanceAmount:
          0,

        discountAmount:
          0,

        paymentMode:
          "offline",

        extraBedRequired:
          false,

        extraBedCount:
          0,

      };


      try {

        setBookingLoading(
          true
        );


        const bookingSubdomain =
          subdomain ||
          getBookingSubdomain();


        if (!bookingSubdomain) {

          throw new Error(
            "Unable to determine booking subdomain."
          );

        }


        const response =
          await createBooking({

            subdomain:
              bookingSubdomain,

            bookingPayload,

          });


        console.log(
          "✅ BOOKING RESPONSE:",
          response
        );


        if (
          response?.success ===
          false
        ) {

          throw new Error(
            response?.message ||
            "Booking could not be completed."
          );

        }


        const createdBooking =
          response?.booking;


        if (!createdBooking) {

          throw new Error(
            "Booking was created but booking details were not returned."
          );

        }


        return createdBooking;

      } catch (error) {

        console.error(
          "❌ BOOKING CREATION FAILED:",
          error
        );


        const message =
          error?.response?.data?.message ||
          error?.message ||
          "Unable to create booking.";


        alert(
          message
        );


        throw error;

      } finally {

        setBookingLoading(
          false
        );

      }

    };


  /* =========================================================
     CLOSE MODAL
  ========================================================= */

  const closeBookingModal =
    () => {

      setIsBookingModalOpen(
        false
      );

      setSelectedRoom(
        null
      );

      setBookingSearchDetails(
        null
      );

      setGuestForm(
        DEFAULT_GUEST_FORM
      );

    };


  return {

    offers,

    selectedRoom,

    setSelectedRoom,

    handleRoomSelect,

    bookingSearchDetails,

    setBookingSearchDetails,

    isBookingModalOpen,

    setIsBookingModalOpen,

    closeBookingModal,

    guestForm,

    setGuestForm,

    handleGuestChange,

    bookingLoading,

    handleBookingSubmit,

  };

};


export default useBookingModal;